// Module
var code = "<div class=\"field-row from-control-container column-selector-container\"> <div class=\"head\"> <label>Field to Parse</label> </div> <div class=\"body\"> <div> <div class=\"column-selector\"></div> </div> </div> </div> <div class=\"alias-selector\"></div> ";
// Exports
export default code;